// Path helpers for the Activation Engine feature.
// Centralizes the React Router path-based routes so the Shell navigation, screen
// links and programmatic navigation stay in sync. Replaces the legacy hash
// routing the standalone app used. Mirrors the standalone app's routes.js
// helpers (opportunitiesRoute/monitoringRoute/campaignRoute/campaignBuilderRoute)
// so ported screens can swap their import from ../routes.js to ../navConfig.js.
import routePaths from 'routes/routePaths';

export const ACTIVATION_BASE = routePaths.activationEngine;

export const ACTIVATION_PATHS = {
  base: ACTIVATION_BASE,
  overview: `${ACTIVATION_BASE}/overview`,
  enrollment: `${ACTIVATION_BASE}/enrollment`,
  opportunities: `${ACTIVATION_BASE}/opportunities`,
  secureReview: `${ACTIVATION_BASE}/secure-review`,
  monitoring: `${ACTIVATION_BASE}/monitoring`,
  methodology: `${ACTIVATION_BASE}/methodology`,
  howTo: `${ACTIVATION_BASE}/how-to`,
  campaigns: `${ACTIVATION_BASE}/campaigns`,
  campaignsNew: `${ACTIVATION_BASE}/campaigns/new`,
  campaignsAction: `${ACTIVATION_BASE}/campaigns/action`,
  campaign: (id) => `${ACTIVATION_BASE}/campaigns/${encodeURIComponent(id)}`,
  // Pre-rehaul aliases: the shipped fo build used "/activation" for the campaigns
  // area. These keep pre-existing callers pointing at the new campaigns paths
  // (the navigator also redirects legacy "/activation/*" URLs). Remove once every
  // screen has been re-ported to the campaigns terminology.
  activation: `${ACTIVATION_BASE}/campaigns`,
  activationNew: `${ACTIVATION_BASE}/campaigns/new`,
  activationAction: `${ACTIVATION_BASE}/campaigns/action`,
};

// Legacy route root alias used by the navigator to redirect old bookmarks.
export const LEGACY_ROUTE_ALIASES = Object.freeze({ activation: 'campaigns' });

function routeWithParams(route, params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  const suffix = query.toString();
  return route + (suffix ? `?${suffix}` : '');
}

export const opportunitiesRoute = (params = {}) => routeWithParams(ACTIVATION_PATHS.opportunities, params);
export const monitoringRoute = (params = {}) => routeWithParams(ACTIVATION_PATHS.monitoring, params);
export const campaignRoute = (campaignId, params = {}) =>
  routeWithParams(ACTIVATION_PATHS.campaign(campaignId), params);
export const campaignBuilderRoute = (params = {}) => routeWithParams(ACTIVATION_PATHS.campaignsNew, params);
